import { Button } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {buttonStylesGreen } from '../../Components/docsAdministrative/JsObjectStyles';
import FooterConsulting from '../../Components/shared/Footer/FooterConsulting';
import NavbarConsulting from '../../Components/shared/Navbar/NavbarConsulting';
import { DrawIcon13, DrawIcon14, DrawIcon15, DrawIcon16, DrawIcon17, DrawIcon18 } from '../../data/SVGConsulting';
import {DrawImageHomeExpert26 } from '../../data/SVGs';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
import useWindowSize from '../../hooks/useWindowSize';
import ImageSection from './../../Assets/ConsultingHomePage/section_3_Consulting.png';

function WhyHtHConsulting() {

    const navigate=useNavigate();
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes

    usePersistedLanguage();
    return (
        <>
            <div style={{display:'flex',flexDirection:'column',alignSelf:'stretch',width:'100%',background:'white',height:'fit-content'}}>
                <NavbarConsulting />

                <div style={{display:'flex',flexDirection:'column',gap:'65px',alignItems:'center',alignSelf:'stretch',paddingTop:device == 'desktop' ? '75px':'0px'}}>
                    <div
                        className='homeExpertf44'
                        style={{
                            width:'94%',
                            height:device=='desktop'?'350px':'100%',
                            borderRadius: '20px',
                            background: '#E7EAF9',
                            flexDirection:device=='desktop'?'row':'column',
                        }}
                    >
                        <div className='prqHthframe2'>
                            <h3>
                                {i18n.t('Votre transformation digitale commence ici')}
                            </h3>
                            <p className='prqHthframe4'>
                                {i18n.t('Nous ne nous contentons pas de fournir des conseils, nous sommes vos partenaires de confiance dans chaque étape de votre parcours digital. Grâce à notre approche sur mesure et notre engagement envers l\'excellence, nous vous aidons à atteindre vos objectifs tout en maximisant la valeur de vos investissements IT.')}
                            </p>
                        </div>
                        <div style={{width:device=='desktop'?'47%':'80%',height:'90%'}}>
                            {/* <PrqHthSvg1 height={'100%'} /> */}
                            <img
                                src={ImageSection}
                                style={{height:'100%',borderRadius:'20px'}}
                            />
                        </div>
                    </div>

                    <div
                        style={{
                            display:'grid',
                            gridTemplateColumns:device=='desktop'?'repeat(3,1fr)':'repeat(1,1fr)',
                            gap:'24px',
                            width: '80%',
                            alignItems: 'center',
                            //isolation: 'isolate',
                            maxWidth: '1268px',
                            minWidth: device=='desktop'?'600px':'200px',
                        }}
                    >
                        <div className='homeExpertf47'>
                            <div style={{textAlign:'left',width:'170px',height:'auto'}}>
                                <DrawIcon13 />
                            </div>

                            <div className='homeExpertf48'>
                                <h5
                                    className='homeExpertf16'
                                    style={{margin:0}}
                                >
                                    {i18n.t('Expertise de pointe')}
                                </h5>
                                <p className='homeExpertf49'>
                                    {i18n.t('Notre équipe est composée de professionnels expérimentés et passionnés, spécialisés dans les technologies les plus avancées. Nous vous offrons des solutions innovantes, adaptées à vos besoins, pour garantir la performance et la sécurité de vos systèmes IT.')}
                                </p>
                            </div>
                        </div>

                        <div className='homeExpertf47'>
                            <div style={{textAlign:'left',width:'170px',height:'auto'}}>
                                <DrawIcon14 />
                            </div>
                            <div className='homeExpertf48'>
                                <h5
                                    className='homeExpertf16'
                                    style={{margin:0}}
                                >
                                    {i18n.t('Approche personnalisée')}
                                </h5>
                                <p className='homeExpertf49'>
                                    {i18n.t('Chaque entreprise est unique. C\'est pourquoi nous adaptons nos services pour répondre précisément à vos objectifs et défis. Nous collaborons étroitement avec vous pour concevoir des solutions sur mesure qui s\'alignent parfaitement avec vos priorités stratégiques.')}
                                </p>
                            </div>
                        </div>

                        <div className='homeExpertf47'>
                            <div style={{textAlign:'left',width:'170px',height:'auto'}}>
                                <DrawIcon15 />
                            </div>
                            <div className='homeExpertf48'>

                                <h5
                                    className='homeExpertf16'
                                    style={{margin:0}}
                                >
                                    {i18n.t('Partenaire de confiance')}
                                </h5>
                                <p className='homeExpertf49'>
                                    {i18n.t('Nous ne nous contentons pas de fournir des conseils, nous devenons un véritable partenaire pour accompagner votre croissance. Notre relation est fondée sur la transparence, la fiabilité et un engagement à long terme envers votre succès.')}
                                </p>
                            </div>
                        </div>

                        <div className='homeExpertf47'>
                            <div style={{textAlign:'left',width:'170px',height:'auto'}}>
                                <DrawIcon16 />
                            </div>
                            <div className='homeExpertf48'>
                                <h5
                                    className='homeExpertf16'
                                    style={{margin:0}}
                                >
                                    {i18n.t('Transformation digitale accélérée')}
                                </h5>
                                <p className='homeExpertf49'>
                                    {i18n.t('Avec notre expertise, nous vous aidons à naviguer dans la complexité de la transformation numérique, en optimisant vos processus, en intégrant des solutions modernes et en favorisant l\'agilité au sein de votre organisation.')}
                                </p>
                            </div>
                        </div>

                        <div className='homeExpertf47'>
                            <div style={{textAlign:'left',width:'170px',height:'auto'}}>
                                <DrawIcon17 />
                            </div>
                            <div className='homeExpertf48'>
                                <h5
                                    className='homeExpertf16'
                                    style={{margin:0}}
                                >
                                    {i18n.t('Excellence opérationnelle')}
                                </h5>
                                <p className='homeExpertf49'>
                                    {i18n.t('Nous mettons un point d\'honneur à fournir des solutions d\'une qualité irréprochable. Notre approche rigoureuse, combinée à un souci constant du détail, garantit la réussite de chaque projet dans les délais et les budgets impartis.')}
                                </p>

                            </div>
                        </div>

                        <div className='homeExpertf47'>
                            <div style={{textAlign:'left',width:'170px',height:'auto'}}>
                                <DrawIcon18 />
                            </div>
                            <div className='homeExpertf48'>

                                <h5
                                    className='homeExpertf16'
                                    style={{margin:0}}
                                >
                                    {i18n.t('Support continu et réactif')}
                                </h5>
                                <p className='homeExpertf49'>
                                    {i18n.t('Nous restons à vos côtés à chaque étape de votre projet. Grâce à un service client réactif et à un support technique de qualité, nous veillons à la bonne marche de vos opérations, en anticipant et résolvant rapidement tout problème.')}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className='homeExpertf44'>
                        <div className='homeExpertf45'>
                            <h3 className='frame101HomePage'>
                                {i18n.t('Prêt à donner vie à votre projet avec notre expertise')}
                            </h3>
                            {device!='desktop' &&
                            <DrawImageHomeExpert26 />
                            }
                            <Button
                                style={{...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'}}}
                                onClick={()=>{
                                    navigate('/ContactUs');
                                }}
                            >
                                {i18n.t('Nous contacter')}
                            </Button>
                        </div>
                        {device=='desktop' &&
                        <DrawImageHomeExpert26 />
                        }
                    </div>

                </div>
                <FooterConsulting
                    styleProps={{background: '#005E23',
                    }}
                />
            </div>
        </>
    );
}

export default WhyHtHConsulting;